<template>
    <div>
        <el-row>
            <el-col>
                <el-card class="set-card box-card">
                    <div class="text item">
                        <el-row class="info-item set-pd" @click.native="toParticulars(false)">

                            <el-col :span="24">
                                <el-row>
                                    <el-col :span="16">
                                        <h5>天黎优品科技有限公司<span>急招</span></h5>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="10">
                                        <p class="info">
                                            <span>佛挡杀佛</span>|
                                            <span>20-99人</span>|
                                            <span>辅导费</span>
                                        </p>
                                    </el-col>
                                    <el-col :span="14">
                                        <p class="addr">地址：发斯蒂芬斯蒂芬fdsfsdfs</p>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-row>
                                <el-col :span="24" class="content">
                                    <p>1.范德萨范德萨发水电费所发生的发生的</p>
                                    <p>2.范德萨范德萨发水电费所发生的发生的</p>
                                    <p>3.范德萨范德萨发水电费所发生的发生的</p>
                                </el-col>
                            </el-row>
                            
                        </el-row>
                        <el-divider class="line"></el-divider>
                    </div>
                     <div class="text item">
                        <el-row class="info-item set-pd" @click.native="toParticulars(false)">

                            <el-col :span="24">
                                <el-row>
                                    <el-col :span="16">
                                        <h5>天黎优品科技有限公司<span>急招</span></h5>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="10">
                                        <p class="info">
                                            <span>佛挡杀佛</span>|
                                            <span>20-99人</span>|
                                            <span>辅导费</span>
                                        </p>
                                    </el-col>
                                    <el-col :span="14">
                                        <p class="addr">地址：发斯蒂芬斯蒂芬fdsfsdfs</p>
                                    </el-col>
                                </el-row>
                            </el-col>
                            <el-row>
                                <el-col :span="24" class="content">
                                    <p>1.范德萨范德萨发水电费所发生的发生的</p>
                                    <p>2.范德萨范德萨发水电费所发生的发生的</p>
                                    <p>3.范德萨范德萨发水电费所发生的发生的</p>
                                </el-col>
                            </el-row>
                            
                        </el-row>
                        <el-divider class="line"></el-divider>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return {
            src:'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg'
        }
    },
    methods:{
        toParticulars(status){
            this.$emit('statusFun',status)
        }
    }
}
</script>
<style lang="less" scoped>
    .info-item{
        padding:10px;
        h5{            
            font-size: 18px;
            font-weight: 500;
            color: #343434;
            line-height: 30px;
            span{
                font-size: 14px;            
                color: #FF811A;
                margin-left:10px;
            }
        }
        p.info{  
            margin-top:10px;      
            color: #343434;
            span:first-of-type{
                padding-left:0;
            }
            span{
                padding:10px;        
                font-size: 14px;
                font-weight: 400; 
            }
        }
        p.addr{
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 40px;
            float:right;
        }

        .content{     
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 24px;
        }

    }
    
</style>